export default function PageHero(props) {
  const {
    title,
    description,
    align = "left",
    compact = false,
    badge,
  } = props;

  return (
    <section className={`ags-page-hero ${compact ? "ags-page-hero-compact" : ""}`}>
      <div className="container">
        <div className="row justify-content-center">
          <div
            className={`col-lg-10 ${align === "center" ? "text-center" : ""}`}
          >
            <div className="ags-page-hero-shell" >
              {badge ? <div className="ags-page-hero-badge mb-3">{badge}</div> : null}
              <h1 className="main-section-title mb-3 text-light" data-aos="fade-right">{title}</h1>
              {description ? (
                <p className="ags-hero-description mb-0 text-light opacity-75" data-aos="fade-up">
                  {description}
                </p>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
